export enum EventTypes {
  AUTHENTICATED = 'AUTHENTICATED',
  VERIFIED = 'VERIFIED',
  LOGOUT = 'LOGOUT',
}

/**
 * THe AUTHENTICATED event payload
 */
export interface IAuthenticated {
  token: string;
}

/**
 * THe VERIFIED event payload
 */
export interface IVerified {
  isAuthenticated: boolean;
  email?: string;
  userId?: string;
  userName?: string;
}

/**
 * The state of the auth module
 */
export interface IAuthReducer {
  isAuthenticated: boolean;
  token?: string;
  email?: string;
  userId?: string;
  userName?: string;
  organizationName?: string;
}

export type IReducerPayload = IAuthenticated | IVerified | null;
